export const CATEGORY_CATALOGS = {
  bed: {
    required_parts: ['frame', 'base', 'mattress', 'legs'],
    optional_parts: ['drawers', 'attachedDesk', 'attachedShelves', 'headboard'],
    attributes: {
      inheritable: ['body_color', 'body_material', 'texture', 'edge_thickness'],
      individual: ['mattress_thickness', 'slat_type', 'upholstery', 'upholstery_fabric', 'clearance'],
    },
  },
  wardrobe: {
    required_parts: ['body', 'back_panel', 'facades'],
    optional_parts: ['shelves', 'partitions', 'rod', 'drawers', 'handles', 'plinth'],
    attributes: {
      inheritable: ['body_color', 'body_material', 'shelf_thickness', 'facade_gap'],
      individual: ['facade_color', 'opening_type', 'inner_depth'],
    },
  },
  kitchen_cabinet: {
    required_parts: ['body', 'facades'],
    optional_parts: ['back_panel', 'shelves', 'drawers', 'handles', 'plinth', 'countertop', 'sink_zone'],
    attributes: {
      inheritable: ['body_color', 'body_material', 'shelf_thickness', 'facade_gap'],
      individual: ['cabinet_type', 'toe_kick_depth', 'wall_mount_height', 'opening_type', 'facade_color'],
    },
  },
  bookcase: {
    required_parts: ['vertical_stands', 'horizontal_shelves'],
    optional_parts: ['back_panel', 'stiffeners', 'insert_boxes'],
    attributes: {
      inheritable: ['body_color', 'body_material', 'drilling_step'],
      individual: ['stand_material', 'wall_mount_required', 'stand_thickness', 'shelf_thickness'],
    },
  },
  table: {
    required_parts: ['tabletop', 'supports'],
    optional_parts: ['apron', 'pedestal', 'cable_channel'],
    attributes: {
      inheritable: ['body_color', 'body_material', 'edge_material'],
      individual: ['tabletop_thickness', 'corner_radius', 'table_height'],
    },
  },
  dresser: {
    required_parts: ['body', 'drawer_stack', 'slides'],
    optional_parts: ['top_panel', 'handles', 'legs', 'plinth'],
    attributes: {
      inheritable: ['body_color', 'body_material', 'facade_gap'],
      individual: ['drawers_count', 'slide_type', 'drawer_bottom_material'],
    },
  },
  nightstand: {
    required_parts: ['body', 'bottom_support'],
    optional_parts: ['drawer_stack', 'door', 'top_panel', 'handles'],
    attributes: {
      inheritable: ['body_color', 'body_material', 'facade_gap'],
      individual: ['drawers_count', 'slide_type', 'support_type', 'support_height'],
    },
  },
  shelf: {
    required_parts: ['shelf_board', 'holders'],
    optional_parts: ['borders', 'side_panels'],
    attributes: {
      inheritable: ['body_color', 'body_material'],
      individual: ['max_load_kg', 'mount_type', 'shelf_depth'],
    },
  },
};

export function getCategoryCatalog(category) {
  return CATEGORY_CATALOGS[category] || null;
}
